import React, { useState, useEffect, useRef } from 'react';
import toastr from 'toastr';
import 'toastr/build/toastr.min.css';
import '../ConnectionStatus/ConnectionStatus.css';

function SendUssdModal({ isOpen, onClose, onSendUssd, simCards = [] }) {
  const [requestCode, setRequestCode] = useState('');
  const [selectedSimIndex, setSelectedSimIndex] = useState(0);
  // Оставляем стейт, чтобы не сломать API родительского компонента, но убираем UI
  const [selectedMethod] = useState('executeCommand'); 

  useEffect(() => {
    if (isOpen) {
      setRequestCode('');
      setSelectedSimIndex(simCards.length > 0 ? simCards[0].simSlotIndex : 0);
    }
  }, [isOpen, simCards]);

  if (!isOpen) return null;

  const handleSubmit = () => {
    if (!requestCode.trim()) {
      toastr.warning(' ', 'Команда не может быть пустой.');
      return;
    }
    // Передаем скрытый дефолтный метод
    onSendUssd(requestCode, selectedSimIndex, selectedMethod);
    onClose();
  };

  const renderSimSelection = () => {
    if (!simCards || simCards.length === 0) {
      return <p style={{ color: '#e74c3c', marginBottom: '15px' }}>Нет доступных SIM-карт для отправки.</p>;
    }

    const selectedSim = simCards.find(s => s.simSlotIndex === selectedSimIndex) || simCards[0];
    const isSelectedExtracted = selectedSim && selectedSim.carrierName === 'Извлечена/удалена';

    return (
      <div style={{ marginBottom: '15px', border: '1px solid #444', borderRadius: '4px', padding: '10px' }}>
        <h5 style={{ marginTop: 0, marginBottom: '10px', color: '#ccc' }}>Отправить с SIM:</h5>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
          {simCards.map((sim) => {
            const isExtracted = sim.carrierName === 'Извлечена/удалена';
            return (
              <label key={sim.iccId || sim.simSlotIndex} style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                <input
                  type="radio"
                  name="simCard"
                  value={sim.simSlotIndex}
                  checked={selectedSimIndex === sim.simSlotIndex}
                  onChange={() => setSelectedSimIndex(sim.simSlotIndex)}
                  style={{ marginRight: '5px' }}
                />
                {sim.carrierName && !isExtracted ? sim.carrierName : `SIM ${sim.simSlotIndex + 1}`} ({sim.number || 'Нет номера'}) {isExtracted ? '(❌ Извлечена/удалена)' : ''}
              </label>
            );
          })}
        </div>
        {isSelectedExtracted && (
          <div style={{ color: '#e74c3c', fontSize: '12px', marginTop: '10px' }}>
             ⚠️ Эта SIM-карта была извлечена или возврат пустоты от устройства. Запрос может завершиться ошибкой.
          </div>
        )}
      </div>
    );
  };

  return (
    <div className="modal-backdrop">
      <div className="modal-content" style={{ maxWidth: '450px' }} onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h4>Отправить USSD-команду</h4>
        </div>
        <div className="modal-body">
          {renderSimSelection()}
          <input
            type="text"
            placeholder="*100# или другая команда/Звонок"
            value={requestCode}
            onChange={(e) => setRequestCode(e.target.value)}
            onKeyDown={(e) => { if (e.key === 'Enter') handleSubmit(); }}
            style={{ width: '100%', padding: '10px', marginBottom: '10px', boxSizing: 'border-box' }}
          />
        </div>
        <div className="modal-actions" style={{ justifyContent: 'flex-end' }}>
          <button onClick={onClose}>Отмена</button>
          <button onClick={handleSubmit}>Отправить</button>
        </div>
      </div>
    </div>
  );
}

export default SendUssdModal;